// Bouton LIGHT / DARK : bascule le thème clair/sombre et mémorise le choix.
(() => {
  const KEY = 'sw-theme';
  const root = document.documentElement;

  const read = () => {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  };
  const write = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {
      /* stockage indisponible : le choix ne sera pas mémorisé */
    }
  };

  const apply = (mode) => {
    if (mode === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    document.querySelectorAll('.sw-theme-toggle').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(mode === 'dark'));
      btn.querySelector('.sw-light')?.setAttribute('aria-current', String(mode !== 'dark'));
      btn.querySelector('.sw-dark')?.setAttribute('aria-current', String(mode === 'dark'));
    });
  };

  const mount = () => {
    if (document.querySelector('.sw-theme-toggle')) return;
    const anchor = document.querySelector('header-actions') || document.querySelector('header-component');
    if (!anchor) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sw-theme-toggle';
    btn.setAttribute('aria-label', 'Toggle light / dark mode');
    btn.innerHTML = '<span class="sw-light" aria-current="true">Light</span><span class="sw-dark">Dark</span>';
    btn.addEventListener('click', () => {
      const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      write(next);
      apply(next);
    });
    if (anchor.tagName.toLowerCase() === 'header-actions') anchor.parentNode.insertBefore(btn, anchor);
    else anchor.appendChild(btn);
    apply(read() === 'dark' ? 'dark' : 'light');
  };

  apply(read() === 'dark' ? 'dark' : 'light');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();

// Effet « lettres mélangées » : au clic sur un texte, les lettres se brouillent
// puis se remettent en place de gauche à droite.
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#%&@*+=?';
  const TEXT_SELECTOR = 'h1, h2, h3, h4, h5, h6, p, .jumbo-text';
  const IGNORED = 'a, button, input, select, textarea, label, summary, [role="button"], header, nav';
  const DURATION = 700;
  const running = new WeakSet();

  const textNodes = (el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const list = [];
    while (walker.nextNode()) list.push(walker.currentNode);
    return list;
  };

  // Le texte affiché est réécrit à chaque image. Si le thème le modifie entre-temps
  // (ex. « Ajout… » sur un bouton, compteur du panier), on n'y touche plus et on ne
  // le restaure pas : l'animation ne doit jamais écraser un texte mis à jour.
  const scramble = (el, duration = DURATION) => {
    if (running.has(el)) return;
    const items = textNodes(el).map((node) => ({ node, text: node.nodeValue, shown: node.nodeValue, stale: false }));
    if (!items.length) return;
    running.add(el);
    const start = performance.now();

    const frame = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      for (const item of items) {
        if (item.stale) continue;
        if (item.node.nodeValue !== item.shown) {
          item.stale = true;
          continue;
        }
        const revealed = Math.floor(progress * item.text.length);
        let out = '';
        for (let i = 0; i < item.text.length; i++) {
          const ch = item.text[i];
          out += i < revealed || /\s/.test(ch) ? ch : CHARS[Math.floor(Math.random() * CHARS.length)];
        }
        item.node.nodeValue = out;
        item.shown = out;
      }
      if (progress < 1) {
        setTimeout(() => frame(performance.now()), 20);
      } else {
        for (const item of items) {
          if (!item.stale && item.node.nodeValue === item.shown) item.node.nodeValue = item.text;
        }
        running.delete(el);
      }
    };
    setTimeout(() => frame(performance.now()), 20);
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest(IGNORED)) return;
    const el = target.closest(TEXT_SELECTOR);
    if (el) scramble(el);
  });

  // Tous les liens et boutons du site (menu, compte, panier, recherche, pied de page,
  // formulaires…) : l'effet se déclenche au survol, ou au toucher sur mobile.
  // On ignore le logo (police proportionnelle : la largeur changerait), les éléments
  // désactivés et les liens contenant un long texte (cartes entières).
  const INTERACTIVE = 'a[href], button, summary, [role="button"], [role="tab"], [role="menuitem"], .button, .button-secondary, .link, shopify-account, .header-actions__action';
  const SKIP = '.header-logo, [data-no-scramble], [disabled], button[aria-disabled="true"]';
  const MAX_LENGTH = 60;

  const interactiveFrom = (target) => {
    if (!(target instanceof Element)) return null;
    const el = target.closest(INTERACTIVE);
    if (!el || el.closest(SKIP)) return null;
    return el.textContent.trim().length > MAX_LENGTH ? null : el;
  };

  // Pied de page : les titres et textes (Boutique, Suivez-nous, Newsletter, copyright…) réagissent aussi au survol
  const FOOTER_TEXT = 'footer p, footer h1, footer h2, footer h3, footer h4, footer h5, footer h6';
  const footerTextFrom = (target) => {
    if (!(target instanceof Element)) return null;
    const el = target.closest(FOOTER_TEXT);
    if (!el || el.closest('a, button, [data-no-scramble]')) return null;
    return el.textContent.trim().length > MAX_LENGTH ? null : el;
  };

  document.addEventListener('mouseover', (event) => {
    const el = interactiveFrom(event.target) || footerTextFrom(event.target);
    if (el && !el.contains(event.relatedTarget)) scramble(el, 450);
  });
  document.addEventListener('touchstart', (event) => {
    const el = interactiveFrom(event.target);
    if (el) scramble(el, 450);
  }, { passive: true });})();

// Sélecteur de langue « FR — EN » dans l'en-tête (utilise le formulaire Shopify sw-language-form).
(() => {
  const mount = () => {
    if (document.querySelector('.sw-lang-toggle')) return;
    const form = document.getElementById('SwLanguageForm');
    const data = document.getElementById('SwLanguages');
    if (!form || !data) return;

    let languages;
    try {
      languages = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(languages) || languages.length < 2) return;

    const anchor = document.querySelector('header-actions') || document.querySelector('header-component');
    if (!anchor) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sw-lang-toggle';
    const current = languages.find((l) => l.active) || languages[0];
    btn.setAttribute('aria-label', 'Language: ' + current.name);
    languages.forEach((l) => {
      const span = document.createElement('span');
      span.textContent = l.label;
      span.lang = l.code;
      span.dataset.code = l.code;
      span.setAttribute('aria-current', String(l.active));
      btn.appendChild(span);
    });

    btn.addEventListener('click', (event) => {
      // Un clic sur une langue précise la choisit ; ailleurs, on passe à la langue suivante.
      const target = event.target.closest('[data-code]');
      const idx = languages.findIndex((l) => l.active);
      const next = target && !languages.find((l) => l.code === target.dataset.code).active
        ? languages.find((l) => l.code === target.dataset.code)
        : languages[(idx + 1) % languages.length];
      const input = form.querySelector('input[name="language_code"]');
      if (input) input.value = next.code;
      form.submit();
    });

    if (anchor.tagName.toLowerCase() === 'header-actions') anchor.parentNode.insertBefore(btn, anchor);
    else anchor.appendChild(btn);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();


// Favoris : cœur sur les produits (réservé aux clients connectés). La liste est mémorisée dans le navigateur, par compte.
(() => {
  const customerId = window.SW_CUSTOMER;
  const KEY = customerId ? 'sw-favs-' + customerId : null;
  const t = (text) => (window.swI18n ? window.swI18n.t(text) : text);
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.4-9.2C1.2 8 3.2 4.8 6.5 4.8c1.9 0 3.5 1 4.5 2.6.3.4.9.4 1.2 0 1-1.6 2.6-2.6 4.5-2.6 3.3 0 5.3 3.2 3.9 6.5-1.9 4.6-9.4 9.2-9.4 9.2z"/></svg>';

  const read = () => {
    if (!KEY) return [];
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((x) => x && typeof x.handle === 'string') : [];
    } catch (e) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* stockage indisponible : les favoris ne seront pas mémorisés */
    }
  };

  const loginUrl = () => {
    const base = window.SW_LOGIN_URL || '/account/login';
    return base + (base.includes('?') ? '&' : '?') + 'return_url=' + encodeURIComponent(location.pathname + location.search);
  };

  let toastTimer;
  const toast = (message, linkLabel, href) => {
    let box = document.querySelector('.sw-toast');
    if (!box) {
      box = document.createElement('div');
      box.className = 'sw-toast';
      box.setAttribute('role', 'status');
      document.body.appendChild(box);
    }
    box.textContent = t(message) + ' ';
    if (href) {
      const a = document.createElement('a');
      a.href = href;
      a.textContent = t(linkLabel);
      box.appendChild(a);
    }
    box.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => box.classList.remove('is-visible'), 5000);
  };

  const paint = () => {
    const handles = new Set(read().map((x) => x.handle));
    document.querySelectorAll('[data-sw-fav]').forEach((btn) => {
      const on = handles.has(btn.dataset.handle);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', t(on ? 'Remove from favorites' : 'Add to favorites'));
      const label = btn.querySelector('.sw-heart__label');
      const text = t(on ? 'Saved to favorites' : 'Save to favorites');
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('.sw-fav-count').forEach((el) => {
      const count = handles.size ? String(handles.size) : '';
      if (el.textContent !== count) el.textContent = count;
      el.hidden = !handles.size;
    });
  };

  const toggle = (handle) => {
    if (!customerId) {
      toast('Log in to save your favorites.', 'Log in', loginUrl());
      return;
    }
    let list = read();
    if (list.some((x) => x.handle === handle)) list = list.filter((x) => x.handle !== handle);
    else list = [{ handle, at: Date.now() }, ...list];
    write(list);
    paint();
    document.dispatchEvent(new CustomEvent('sw:favs-changed'));
  };

  window.swFavs = { list: read, toggle, paint, loggedIn: !!customerId, loginUrl };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-sw-fav]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.dataset.handle);
  });

  const handleOf = (href) => {
    const m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  };

  // Cœur sur les cartes produit du thème + lien « Favoris » dans l'en-tête + cœur sur la page produit
  const inject = () => {
    document.querySelectorAll('.card-gallery[data-product-id]').forEach((gallery) => {
      if (gallery.querySelector('.sw-heart')) return;
      const handle = handleOf(gallery.querySelector('a[href*="/products/"]')?.getAttribute('href'));
      if (!handle) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sw-heart';
      btn.dataset.swFav = '';
      btn.dataset.handle = handle;
      btn.dataset.productId = gallery.dataset.productId;
      btn.dataset.noScramble = '';
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = HEART;
      gallery.appendChild(btn);
    });

    if (window.SW_PRODUCT && !document.querySelector('.sw-heart--inline')) {
      const title = document.querySelector('main h1');
      if (title) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sw-heart sw-heart--inline';
        btn.dataset.swFav = '';
        btn.dataset.handle = window.SW_PRODUCT;
        btn.dataset.noScramble = '';
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML = HEART + '<span class="sw-heart__label">' + t('Save to favorites') + '</span>';
        title.insertAdjacentElement('afterend', btn);
      }
    }

    if (!document.querySelector('.sw-fav-link')) {
      const anchor = document.querySelector('header-actions');
      if (anchor) {
        const link = document.createElement('a');
        link.className = 'sw-fav-link';
        link.href = window.SW_FAV_URL || '/pages/favorites';
        link.dataset.noScramble = '';
        link.setAttribute('aria-label', t('Favorites'));
        link.innerHTML = HEART + '<span class="sw-fav-count" hidden></span>';
        anchor.prepend(link); // dans le conteneur flex des actions : ne chevauche pas le compte ni le panier
      }
    }
    paint();
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      inject();
    });
  };

  const start = () => {
    inject();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

// Flèche « retour » : sur toutes les pages sauf l'accueil, ramène à la page précédente.
(() => {
  const start = () => {
    const main = document.querySelector('#MainContent');
    if (!main || document.querySelector('.sw-back')) return;
    const template = main.dataset.template || '';
    if (!template || template === 'index' || template === 'password') return;

    const t = (text) => (window.swI18n ? window.swI18n.t(text) : text);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const wrap = document.createElement('div');
    wrap.className = 'sw-back-wrap';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sw-back';
    btn.dataset.noScramble = '';
    btn.setAttribute('aria-label', t('Back'));
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5m0 0 6-6m-6 6 6 6"/></svg>';
    btn.addEventListener('click', () => {
      let sameSite = false;
      try {
        sameSite = !!document.referrer && new URL(document.referrer).origin === location.origin;
      } catch (e) {
        sameSite = false;
      }
      // Sans page précédente sur le site (lien direct), on retourne au catalogue ou à l'accueil
      if (sameSite && history.length > 1) history.back();
      else location.href = template === 'product' ? root + 'collections/all' : root;
    });
    wrap.appendChild(btn);
    main.insertAdjacentElement('afterbegin', wrap);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

// Flèche « haut de page » : apparaît quand on a descendu la page, ramène tout en haut au clic.
(() => {
  const start = () => {
    if (document.querySelector('.sw-totop')) return;
    const t = (text) => (window.swI18n ? window.swI18n.t(text) : text);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sw-totop';
    btn.dataset.noScramble = '';
    btn.setAttribute('aria-label', t('Back to top'));
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5m0 0-6 6m6-6 6 6"/></svg>';
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    document.body.appendChild(btn);

    let queued = false;
    const update = () => {
      queued = false;
      btn.classList.toggle('is-visible', window.scrollY > 400);
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();